import { ChangeEvent, ReactNode } from 'react'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import TextField from '@mui/material/TextField'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { selectName } from '../model/selectors/selectName'
import { newApplicationActions } from '../model/slices/newApplicationSlice'
import { SxProps } from '@mui/material'

interface AppNameInputProps {
	styles: SxProps
	register?: UseFormRegister<any>
	validationErrors?: FieldErrors<any>
}

export const AppNameInput = (props: AppNameInputProps) => {
	const { register, validationErrors: errors, styles } = props
	const dispatch = useAppDispatch()

	const name = useAppSelector(selectName)

	const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
		dispatch(newApplicationActions.setName(e.target.value))
	}

	return (
		<TextField
			required
			fullWidth
			sx={styles}
			variant="outlined"
			id="application-name-input"
			label="Application name"
			helperText={
				(errors?.name?.message as ReactNode) || ''
			}
			error={!!errors?.name?.message}
			{...register?.('name', {
				required: 'This field is required'
			})}
			value={name || ''}
			onChange={handleNameChange}
		/>
	)
}